import React from 'react';
import Banner from '../components/Banner';
import AboutSection from '../components/AboutSection';
import WhyChooseSection from '../components/WhyChooseSection';
import NewsEvents from '../components/NewsEvents';
import CoursesSection from '../components/CoursesSection';
import ContactSection from '../components/ContactSection';

const HomePage = () => {
  return (
    <>
      <Banner/>
      <AboutSection />
      <WhyChooseSection />
      <NewsEvents />
      <CoursesSection />
      <ContactSection />
    </>
  );
};

export default HomePage;